import React from "react";
import { Goals } from "../../models/Goals";
import CardCotainer, { Card } from "../../ui-elements/CardContainer/CardContainer";
import "../Goal/Goal.scss";

import Anything from '../../assets/Anything.png';
import FullyPlantBased from '../../assets/FullyPlantBased.png';
import Paleo from '../../assets/Paleo.png';
import Meditteranean from '../../assets/Meditteranean.png';
import Ketogenic from '../../assets/Ketogenic.png';
import Vegetarian from '../../assets/Vegetarian.png';
import { AnalyticsApi } from "../../api/user";

interface EatingStyleProp {
	goal: Goals;
	valueSelected(response?: any): void;
}

const EatingStyle: React.FC<EatingStyleProp> = ({ goal, valueSelected }): JSX.Element => {
	const [selectedIndex, setSelectedIndex] = React.useState(typeof goal.eatingStyle !== "undefined" ? goal.eatingStyle : -1);
	const [enabled, setEnabled] = React.useState(false);
	const eatingStyles: Card[] = [
		{
			index: 0,
			imageUrl: Anything,
			title: "Anything",
			body: "No major preferences or restrictions. Will eat practically anything.",
			extendedBody: "The “anything” eating style means you like a varied diet, are open to trying new foods, and don't have any specific restrictions. With this approach, you'll enjoy a wide range of healthful whole foods."
		},
		{
			index: 1,
			imageUrl: Meditteranean,
			title: "Mediterranean",
			body: "Features plant foods, healthy fats, and moderate amounts of lean protein.",
			extendedBody: "The Mediterranean eating style emphasizes a plant-rich diet, with lots of vegetables, fruits, whole grains, legumes, olive oil, nuts, and seeds. It also encourages moderate amounts of fish, poultry, eggs, and dairy."
		},
		{
			index: 2,
			imageUrl: Paleo,
			title: "Paleo",
			body: " Emphasizes meats, vegetables, and healthy fats.",
			extendedBody: "The Paleo eating style emphasizes red meat (especially grass-fed), poultry, and fish, along with lots of vegetables, some fruits, and plenty of healthy fats. It requires you to severely limit grains, beans, legumes, and dairy."
		},
		{
			index: 3,
			imageUrl: Vegetarian,
			title: "Vegetarian",
			body: "A plant-based diet, plus small amounts of eggs and dairy.",
			extendedBody: "The vegetarian eating style emphasizes plants, with plenty of whole grains, legumes, vegetables, fruits, nuts, and seeds, along with small amounts of eggs and dairy. No red meat, pork, poultry, or fish."
		},
		{
			index: 4,
			imageUrl: Ketogenic,
			title: "Ketogenic",
			body: "A high-fat, very-low carbohydrate diet.",
			extendedBody: "The ketogenic eating style emphasizes a diet rich in fats, with moderate amounts of protein. It severely restricts carbohydrates, including grains, beans, legumes, potatoes, and fruits. Butters, oils, and red meat are encouraged."
		},
		{
			index: 5,
			imageUrl: FullyPlantBased,
			title: "Fully Plant-Based",
			body: "All plant-based foods. No animal products of any kind.",
			extendedBody: "The fully plant-based eating style includes lots of whole grains, legumes, vegetables, fruits, nuts, seeds, and oils. All animal products are restricted. Protein-rich plant foods such as tempeh, tofu, and seitan are also encouraged."
		},
	];

	const cardClicked = (index: number) => {
		goal.setEatingStyle(index);
		setSelectedIndex(index);
		setEnabled(true);
	};

	const valueClicked = () => {
		AnalyticsApi.logEvent('Eating Style Selected');
		valueSelected();
	};

	React.useEffect(() => {
		if (typeof goal.eatingStyle !== "undefined") {
			setEnabled(true);
		}
	}, []);

	return (
		<div className="content">
			<CardCotainer cardList={eatingStyles} selectedIndex={selectedIndex} valueSelected={cardClicked}></CardCotainer>
			<div className="">
				{enabled ? (
					<button className="greenButton" onClick={(e) => valueClicked()}>
						Next
					</button>
				) : (
					<button className="lightGrayButton">Next</button>
				)}
			</div>
		</div>
	);
};

export default EatingStyle;
